import { ContentLink } from "@components/cms/link/ContentLink";
import {
    linkItemStyles,
    smallHeadingStyles,
    titleLinkStyles,
} from "@components/layouts/navigation/styles";
import type { NavigationColumn } from "@lib/contentful/mappers/mapNavigation";
import { DESKTOP_SUB_ITEM } from "@e2e/helpers/navigation/constants";
import { Text } from "@ecco/ui/text";
import { List, ListItem } from "@ecco/ui/list";
import { Box } from "@ecco/ui/box";
import type { FC } from "react";

interface IDesktopSubNavItemProps {
    title?: string;
    titleLink?: NavigationColumn["titleLink"];
    links: NavigationColumn["links"];
}

export const DesktopSubNavItem: FC<IDesktopSubNavItemProps> = ({ title, titleLink, links }) => {
    return (
        <Box mb="8" data-testid={DESKTOP_SUB_ITEM}>
            {titleLink ? (
                <ContentLink sx={titleLinkStyles} link={titleLink.contentLink}>
                    {title ?? titleLink.label}
                </ContentLink>
            ) : (
                <Text {...smallHeadingStyles}>{title}</Text>
            )}
            {links.length > 0 && (
                <List>
                    {links.map((link) => {
                        return (
                            <ListItem key={link.id} marginBottom={2}>
                                <ContentLink sx={linkItemStyles} link={link.contentLink} />
                            </ListItem>
                        );
                    })}
                </List>
            )}
        </Box>
    );
};
